// test1005
(1005 && 0);
